<template>
	<div style="height: 100%;display: flex;flex-direction: column;">
		<el-form :inline="true" :model="formInline" class="demo-form-inline" style="">
			<el-form-item label="审批人"><el-input v-model="formInline.user" placeholder="审批人"></el-input></el-form-item>
			<el-form-item label="活动区域">
				<el-select v-model="formInline.region" placeholder="活动区域">
					<el-option label="区域一" value="shanghai"></el-option>
					<el-option label="区域二" value="beijing"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item><el-button type="primary" @click="onSubmit">查询</el-button></el-form-item>
		</el-form>
		<el-table sortable="true" :data="tableData" style="width: 100%;height: 100%;" >
			<el-table-column fixed prop="health_name" label="姓名" width="" align="center"></el-table-column>
			<el-table-column prop="health_idcard" label="身份证号" width="" align="center"></el-table-column>
			<el-table-column prop="health_tel" label="手机号" width="" align="center"></el-table-column>
			<el-table-column prop="health_state" label="当前颜色" sortable="true" type="expand" width="200" align="center">
				<template slot-scope="props">
					<el-form label-position="left" inline class="demo-table-expand">
						<el-form-item label="商品名称">
							<span>{{ props.row.name }}</span>
						</el-form-item>
						<el-form-item label="在阿克陶是否有固定住所？">
							<span>{{ props.row.is_home_in_akt }}</span>
						</el-form-item>
						<el-form-item label="最近14天是否离开过阿克陶？">
							<span>{{ props.row.is_out_akt }}</span>
						</el-form-item>
						<el-form-item label="是否在家隔离或居家观察中？">
							<span>{{ props.row.is_look_home }}</span>
						</el-form-item>
						<el-form-item label="是否有发热，气促，呼吸道症？">
							<span>{{ props.row.is_fever }}</span>
						</el-form-item>
						<el-form-item label="健康状态是否有异常？">
							<span>{{ props.row.is_health }}</span>
						</el-form-item>
						<el-form-item label="最近14天去过的地方">
							<span>{{ props.row.desc }}</span>
						</el-form-item>
					</el-form>
				</template>
			</el-table-column>
			<el-table-column prop="add_datetime" label="申请时间" sortable="true" width="" align="center"></el-table-column>
			<el-table-column prop="health_home_area" label="行政划区" width="" align="center"></el-table-column>
			<el-table-column prop="health_home_address" label="家庭住址" width="" align="center"></el-table-column>
		</el-table>
		<div style="display: flex;justify-content: flex-end;">
			<el-pagination
				@size-change="handleSizeChange"
				@current-change="handleCurrentChange"
				:current-page="currentPage4"
				:page-sizes="[20, 50, 100]"
				:page-size="20"
				layout="total, sizes, prev, pager, next, jumper"
				:total="total"
			></el-pagination>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			tableData: [],
			formInline: {},
			currentPage:1,
			total:0
		};
	},
	methods: {
		handleSizeChange(val) {
		        console.log(`每页 ${val} 条`);
		      },
		      handleCurrentChange(val) {
		        console.log(`当前页: ${val}`);
		      }
		
	},
	mounted() {
	}
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/jiankangshenbaojiankong.vue